import React from 'react';
import { ArrowRight, FileText, User, Calendar as CalendarIcon, Mail, HelpCircle, CheckCircle, ExternalLink } from 'lucide-react';

const Inscricao = () => {
    const formUrl = "https://docs.google.com/forms/d/e/1FAIpQLScAsdfxE5E4kbRW3NtoFy0QoyHQkqdOzvqNrt69w_p7Rkzmsg/viewform";

    const handleInscricao = () => {
        window.open(formUrl, '_blank');
    };

    const requirements = [
        { icon: <FileText className="w-4 h-4" />, text: "Documento de identificação" },
        { icon: <User className="w-4 h-4" />, text: "Número de estudante (se disponível)" },
        { icon: <CalendarIcon className="w-4 h-4" />, text: "Ano de graduação" },
        { icon: <Mail className="w-4 h-4" />, text: "Informações de contacto actualizadas" },
    ];

    const notes = [
        "O processo de inscrição leva aproximadamente 5-10 minutos",
        "Todas as informações fornecidas serão tratadas com confidencialidade",
        "Você receberá uma confirmação por email após a submissão",
    ];

    return (
        <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">

            {/* Main Card - Alargado */}
            <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                    {/* Hero Section */}
                    <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 px-8 py-12 text-center">
                        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm mb-5">
                            <CheckCircle className="w-10 h-10 text-white" />
                        </div>
                        <h2 className="text-3xl font-light text-white mb-2">
                            Bem-vindo à Comunidade Alumni
                        </h2>
                        <p className="text-emerald-100 text-base">
                            Faça parte da rede de graduados da Universidade Eduardo Mondlane
                        </p>
                    </div>

                    {/* Content */}
                    <div className="p-8 md:p-10 space-y-8">
                        {/* Requirements Section */}
                        <div>
                            <div className="flex items-center gap-2 mb-5">
                                <FileText className="w-5 h-5 text-emerald-500" />
                                <h2 className="text-lg font-medium text-gray-700">
                                    Antes de Começar
                                </h2>
                            </div>
                            <p className="text-gray-500 text-sm mb-5">
                                Por favor, tenha em mãos os seguintes documentos e informações:
                            </p>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {requirements.map((req, index) => (
                                    <div key={index} className="flex items-center gap-3 p-4 bg-gray-50/50 rounded-xl hover:bg-gray-50 transition-colors">
                                        <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center flex-shrink-0">
                                            <div className="text-emerald-500">
                                                {req.icon}
                                            </div>
                                        </div>
                                        <span className="text-sm text-gray-700">{req.text}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Notes Section */}
                        <div className="bg-emerald-50/30 rounded-xl p-6 border border-emerald-100">
                            <div className="flex items-center gap-2 mb-4">
                                <HelpCircle className="w-5 h-5 text-emerald-500" />
                                <h3 className="text-base font-medium text-gray-700">
                                    Notas Importantes:
                                </h3>
                            </div>
                            <div className="space-y-3">
                                {notes.map((note, index) => (
                                    <div key={index} className="flex items-start gap-3">
                                        <CheckCircle className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                                        <span className="text-sm text-gray-600">{note}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Button */}
                        <div className="pt-4">
                            <button
                                onClick={handleInscricao}
                                className="w-full inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-4 rounded-xl text-base font-medium transition-colors shadow-sm group"
                            >
                                <span>Iniciar Inscrição</span>
                                <ExternalLink className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </button>
                        </div>

                        {/* Help Text */}
                        <p className="text-center text-sm text-gray-400">
                            Precisa de ajuda? Entre em contacto conosco através do email{' '}
                            <a
                                href="mailto:suporte.alumni@uem.ac.mz"
                                className="text-emerald-600 hover:text-emerald-700 transition-colors font-medium"
                            >
                                suporte.alumni@uem.ac.mz
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Inscricao;